<template lang="pug">
  .location-details
    .panel.panel-default
      .panel-heading
        .panel-title Location Info
      .panel-body
        .container-fluid
          .row
            label.col-sm-2.control-label Name
            .col-sm-4 {{location.name}}
            label.col-sm-2.control-label Address
            .col-sm-4 {{location.address}}

          .row
            label.col-sm-2.control-label GLN
            .col-sm-4 {{location.gln}}
            label.col-sm-2.control-label ZIP
            .col-sm-4 {{location.zipCode}}

          .row
            label.col-sm-2.control-label City
            .col-sm-4 {{location.city}}
            label.col-sm-2.control-label Country
            .col-sm-4(v-if="location.country")
              FamFlag(v-if="location.country.code" :code="location.country.code")
              span.ml5 {{location.country.name}}
</template>

<script>
import FamFlag from '@/components/common/FamFlag'

export default {
  props: {
    location: {
      type: null,
      required: true
    }
  },
  components: {
    FamFlag
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/locationportal/components/LocationDetails.vue